import { render } from "./OnboardingContainer.vue?vue&type=template&id=3976bd88&scoped=true"
import script from "./OnboardingContainer.vue?vue&type=script&lang=js"
export * from "./OnboardingContainer.vue?vue&type=script&lang=js"

import "./OnboardingContainer.vue?vue&type=style&index=0&id=3976bd88&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3976bd88"]])

export default __exports__